export const subjectsLength = state => state.subjects.length

export const findSubject = (state, id) => state.subjects.find(s => s.id === id)

export const sortedSubjects = state => state.subjects.sort((a, b) => a.name > b.name)

export const isLoaded = state => state.isLoaded

export default {
  findSubject,
  isLoaded,
  subjectsLength,
  sortedSubjects
}
